import { render, staticRenderFns } from "./vista-linkage-screen.html?vue&type=template&id=0c988c4a&scoped=true&external"
import script from "./vista-linkage-screen.js?vue&type=script&lang=js&external"
export * from "./vista-linkage-screen.js?vue&type=script&lang=js&external"
import style0 from "./vista-linkage-screen.scss?vue&type=style&index=0&id=0c988c4a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c988c4a",
  null
  
)

export default component.exports